import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces/featured-types';

export interface FeaturedType {
    key: string;
    value: string;
}

export interface GetFeaturedTypesSuccessResponse {
    status: number;
    success: boolean;
    message: string;
    data: FeaturedType[];
    links: Record<string, unknown>;
}

/**
 * Requests endpoint to get all featured types.
 */
export const useGetFeaturedTypes = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [featuredTypes, setFeaturedTypes] = useState<GetFeaturedTypesSuccessResponse['data']>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetFeaturedTypesSuccessResponse = await response.json();

            setFeaturedTypes(data.data);
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, featuredTypes, loading };
};
